export default "__VITE_ASSET__BBk9qV9J__"